import React from 'react';

/**
 * Marca TuPlazita: ícono oficial (public/logo-tuplazita.svg) + wordmark.
 */
const BrandLogo: React.FC<{ size?: number; light?: boolean; iconOnly?: boolean }> = ({ size = 40, light = false, iconOnly = false }) => (
  <div style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.26 }}>
    <img src="/logo-tuplazita.svg" alt="TuPlazita" width={size} height={size} style={{ display: 'block', flexShrink: 0 }} />
    {!iconOnly && (
      <span style={{ fontSize: size * 0.62, fontWeight: 800, letterSpacing: '-0.02em', color: light ? '#fff' : '#1e293b', lineHeight: 1 }}>
        Tu<span style={{ color: light ? '#bfdbfe' : '#0066ff' }}>Plazita</span>
      </span>
    )}
  </div>
);

export default BrandLogo;
